import {
  Col,
  DatePicker,
  DatePickerProps,
  Form,
  Input,
  message,
  Row,
  Select,
  Upload
} from "antd";
import dayjs from "dayjs";
import { get, toNumber } from "lodash";
import includes from "lodash/includes";
import { SetStateAction, useEffect, useState } from "react";
import cookie from "react-cookies";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormActionButton from "src/components/common/FormActionButton";
import { messages } from "src/constants/messages";
import EditorInput from "src/routes/Commom/EditorInput";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import { beforeUploadIMG } from "src/util/Commom";
import configUrl from "src/util/config";
import { MessageStatusError } from "src/util/MessageStatus";

import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

const FormItem = Form.Item;
const { TextArea } = Input;
const initialState = {
  idLoaiTuLieu: undefined,
  anhDaiDien: "",
  tenTuLieu: "",
  moTa: "",
  chiTiet: "",
  tacGia: "",
  idHan: undefined
};

const ThongTinTuLieuForm = ({ setIdTuLieu, setKeyTab, setTrangThais }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [type, setType] = useState("new");
  const [fieldTouch, setFieldTouch] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [form] = Form.useForm();
  const { idLoaiTuLieu, tenTuLieu, moTa, tacGia, idHan } = initialState;
  const { validateFields, setFieldsValue } = form;
  const [isLoadDanToc, setIsLoadDanToc] = useState(false);
  const [listDanToc, setListDanToc] = useState([]);
  const [isLoadingLoaiTuLieu, setIsLoadingLoaiTuLieu] = useState(false);
  const [listLoaiTuLieu, setListLoaiTuLieu] = useState([]);
  const [isLoadingHan, setIsLoadingHan] = useState(false);
  const [listHanLuuTru, setListHanLuuTru] = useState([]);
  const [loadingImg, setloadingImg] = useState(false);
  const [isVinhVien, setIsVinhVien] = useState(false);
  const [anhDaiDien, setAnhDaiDien] = useState("");
  const [maDanToc, setMaDanToc] = useState("");
  const [chiTiet, setChiTiet] = useState("");
  const [ngayBatDauLT, setNgayBatDauLT] = useState<any>(new Date().valueOf());
  const [ngayKetThucLT, setNgayKetThucLT] = useState<any>(new Date().valueOf());
  const { tulieuid, idnhomtulieu } = useParams();
  const [itemEdit, setItemEdit] = useState<any>({});
  const [trangThai, setTrangThai] = useState(1);

  useEffect(() => {
    const load = () => {
      if (includes(location.pathname, "them-moi")) {
        setType("new");
      } else {
        setType("edit");
        getInfo(tulieuid);
      }
    };
    getLoaiTuLieu();
    getHanLuuTru();
    getDanToc();
    load();
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["infoTuLieu"]);
    };
  }, []);

  const getDanToc = async () => {
    setIsLoadDanToc(true);
    const configAPI = {
      url: `api/dmdc/dantocs`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listDanToc"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        setListDanToc(get(response, "data", []));
        setIsLoadDanToc(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setIsLoadDanToc(false);
    }
  };

  const getLoaiTuLieu = async () => {
    setIsLoadingLoaiTuLieu(true);
    const configAPI = {
      url: `api/loaitulieus?keyword&idnhomtulieu=${idnhomtulieu}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listLoaiTuLieu"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        setListLoaiTuLieu(get(response.data, "content", []));
        setIsLoadingLoaiTuLieu(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setIsLoadingLoaiTuLieu(false);
    }
  };

  const getHanLuuTru = async () => {
    setIsLoadingHan(true);
    const configAPI = {
      url: `api/hanluutrus?keyword=`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listThoiHanLuuTru"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        setListHanLuuTru(get(response.data, "content", []));
        setIsLoadingHan(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setIsLoadingHan(false);
    }
  };

  /**
   * getInfo : Lấy thông tin
   * @memberof  videoForm
   */
  const getInfo = async (tulieuid: any) => {
    if (location.state && location.state.itemData) {
      // Nếu có dữ liệu truyền sang
      const res = location.state.itemData;
      const ngayBatDauLT = location.state.itemData.ngayBatDauLT;
      const ngayKetThucLT = location.state.itemData.ngayKetThucLT;
      setNgayBatDauLT(ngayBatDauLT ? ngayBatDauLT.valueOf() : null);
      setNgayKetThucLT(ngayKetThucLT ? ngayKetThucLT.valueOf() : null);
      setAnhDaiDien(location.state.itemData.anhDaiDien);
      setTrangThai(res.trangThai);
      setChiTiet(res.chiTiet);
      setIsVinhVien(res.hanLuuTru.isVinhVien);
      setTrangThais(res.trangThai);
      setFieldsValue({
        video: {
          tenTuLieu: res.tenTuLieu,
          maDanToc: res.maDanToc,
          idLoaiTuLieu: res.idLoaiTuLieu,
          tacGia: res.tacGia,
          moTa: res.moTa,
          idHan: res.idHan,
          ngayBatDauLT: res.ngayBatDauLT ? dayjs(res.ngayBatDauLT) : null,
          ngayKetThucLT: res.ngayKetThucLT ? dayjs(res.ngayKetThucLT) : null,
          chiTiet: res.chiTiet
        }
      });
      setItemEdit(res);
    } else {
      const configAPI = {
        url: `api/tulieu/${tulieuid}`,
        method: "GET",
        value: "",
        apiType: "DETAIL",
        getName: "infoTuLieu"
      };
      const response = await apiCaller(configAPI);
      try {
        if (
          response?.data &&
          (response.status === 200 || response.status === 201)
        ) {
          const res = response?.data;
          const ngayBatDauLT = res.ngayBatDauLT;
          const ngayKetThucLT = res.ngayKetThucLT;
          setNgayBatDauLT(ngayBatDauLT ? ngayBatDauLT.valueOf() : null);
          setNgayKetThucLT(ngayKetThucLT ? ngayKetThucLT.valueOf() : null);
          setAnhDaiDien(res.anhDaiDien);
          setChiTiet(res.chiTiet);
          setTrangThai(res.trangThai);
          setIsVinhVien(res.hanLuuTru.isVinhVien);
          setTrangThais(res.trangThai);
          setFieldsValue({
            video: {
              tenTuLieu: res.tenTuLieu,
              maDanToc: res.maDanToc,
              idLoaiTuLieu: res.idLoaiTuLieu,
              tacGia: res.tacGia,
              moTa: res.moTa,
              idHan: res.idHan,
              ngayBatDauLT: res.ngayBatDauLT ? dayjs(res.ngayBatDauLT) : null,
              ngayKetThucLT: res.ngayKetThucLT
                ? dayjs(res.ngayKetThucLT)
                : null,
              chiTiet: res.chiTiet
            }
          });
          setItemEdit(res);
        } else {
          MessageStatusError(toNumber(response?.status));
        }
      } catch (error) {
        // Xử lý lỗi khi lưu dữ liệu không thành công
      }
    }
  };

  /**
   * handleChangeUploadImage: Hàm upload ảnh cán bộ
   * @param {Object} info
   * @memberof SoYeuLyLichForm
   */
  const handleChangeUploadImage = (info: any) => {
    const { file } = info;
    if (file.status === "uploading") {
      setloadingImg(true);
    }
    if (file.status === "done") {
      message.success(`Tải lên ${file.name} thành công`);
      setloadingImg(false);
      setAnhDaiDien(info.file.response.fileDownloadUri);
    } else if (file.status === "error") {
      message.error(`Tải lên ${file.name} thất bại.`);
    }
  };

  /**
   * goBack : quay lại trang danh sách
   * @memberof  videoForm
   */
  const goBack = () => {
    navigate(`/tu-lieu/idnhomtulieu/${idnhomtulieu}`);
  };

  const onChangeHanTuLieu = (value: { value: string }, option: any) => {
    const soNam = option.soNam;
    const date = ngayKetThucLT ? new Date(ngayKetThucLT) : new Date();
    date.setFullYear(date.getFullYear() + soNam);
    const newTimestamp = date.getTime();
    setNgayKetThucLT(newTimestamp);
    setFieldsValue({
      video: {
        ngayKetThucLT: newTimestamp ? dayjs(newTimestamp) : null
      }
    });
    setIsVinhVien(option.isVinhVien);
  };

  const onChangeDanToc = (value: SetStateAction<string>) => {
    setMaDanToc(value);
  };

  const onChangeNgayBatDauLT: DatePickerProps["onChange"] = (date) => {
    setNgayBatDauLT(date.valueOf());
  };

  const onChangeNgayKetThucLT: DatePickerProps["onChange"] = (date) => {
    setNgayKetThucLT(date.valueOf());
  };
  /**
   * save: Lưu
   * @memberof videoForm
   */
  const save = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values, false);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveData: Lưu dữ liệu
   * @param {object} values
   * @param {boolean} saveQuit
   * @memberof videoForm
   */
  const saveData = async (values: any, saveQuit = false) => {
    const data = values.video;
    data.idNhomTuLieu = idnhomtulieu ? parseInt(idnhomtulieu, 10) : undefined;
    data.isVideo = false;
    data.anhDaiDien = anhDaiDien;
    data.ngayBatDauLT = ngayBatDauLT;
    data.ngayKetThucLT = isVinhVien ? null: ngayKetThucLT;
    data.isHinhAnh = false;
    data.isTuLieu = true;
    data.isSuDung = true;
    data.id = tulieuid ? parseInt(tulieuid, 10) : undefined;
    try {
      let configAPI;
      if (type === "new") {
        data.trangThai = 1;
        configAPI = {
          url: `api/tulieu/create`,
          method: "POST",
          data: data,
          apiType: "ADD",
          isShowMessage: true
        };
      } else {
        data.trangThai = trangThai;
        data.idNguoiDang = itemEdit?.idNguoiDang;
        data.ngayDang = itemEdit.ngayDang;
        configAPI = {
          url: `api/tulieu/update`,
          method: "PUT",
          data: data,
          apiType: "EDIT",
          isShowMessage: true
        };
      }

      const response = await apiCaller(configAPI);
      if (response?.status === 200 || response?.status === 201) {
        if (type === "new") {
          setKeyTab("tu-lieu");
          setIdTuLieu(response.data.idTuLieu);
          getInfo(response.data.idTuLieu);
        }
        setFieldTouch(false);
        setLoadingButton(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingButton(false);
      }
    } catch (error) {
      setLoadingButton(false);
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loadingImg ? <LoadingOutlined /> : <PlusOutlined />}
      <div>Ảnh đại diện</div>
    </button>
  );

  return (
    <Form
      className="form-container wrapper-content-inner"
      layout="vertical"
      form={form}
      name="video-control"
      onFieldsChange={() => setFieldTouch(true)}
    >
      <Row gutter={24}>
        <Col md={8} xs={24} style={{ marginBottom: 5 }}>
          <Upload
            accept=".jpg,.jpeg,.png,.gif"
            action={`${configUrl.API_URL}/api/uploadImageFile`}
            listType="picture-card"
            headers={{
              Authorization: "Bearer ".concat(cookie.load("accessTokenTVDTBDT"))
            }}
            beforeUpload={(file) => beforeUploadIMG(file)}
            name="file"
            onChange={handleChangeUploadImage}
            showUploadList={false}
          >
            {anhDaiDien ? (
              <img
                alt="Tải ảnh lên"
                src={anhDaiDien || "src/assets/images/placeholder.jpg"}
                style={{ width: "100%", height: "100%", padding: 5 }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Col>
        <Col md={16} xs={24}>
          <FormItem
            className="ant-input-group"
            label="Tên tài liệu"
            name={["video", "tenTuLieu"]}
            rules={[
              {
                type: "string",
                required: true,
                message: messages.ERROR_REQUIRED
              }
            ]}
            initialValue={tenTuLieu}
          >
            <Input className="input-item" placeholder="Nhập tên tài liệu" />
          </FormItem>
        </Col>
        <Col md={8} xs={24}>
          <FormItem
            className="ant-input-group"
            label="Dân tộc"
            name={["video", "maDanToc"]}
            rules={[
              {
                type: "string",
                required: true,
                message: messages.ERROR_REQUIRED
              }
            ]}
            initialValue={maDanToc || undefined}
          >
            <Select
              allowClear
              showSearch
              onChange={onChangeDanToc}
              loading={isLoadDanToc}
              placeholder="Chọn dân tộc"
              style={{ width: "100%" }}
              options={listDanToc}
              optionFilterProp="tenGoi"
              filterOption={(input, option: any) =>
                (option?.tenGoi ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              fieldNames={{ label: "tenGoi", value: "maDanToc" }}
            />
          </FormItem>
        </Col>
        <Col md={8} xs={24}>
          <FormItem
            className="QTI-FormItemSelect"
            label="Loại tài liệu"
            name={["video", "idLoaiTuLieu"]}
            initialValue={idLoaiTuLieu || undefined}
            rules={[
              {
                required: true,
                message: messages.ERROR_REQUIRED
              }
            ]}
          >
            <Select
              allowClear
              // onChange={onChangeNhomTuLieu}
              loading={isLoadingLoaiTuLieu}
              placeholder="Chọn loại tài liệu"
              style={{ width: "100%" }}
              options={listLoaiTuLieu}
              fieldNames={{ label: "tenLoaiTuLieu", value: "id" }}
            />
          </FormItem>
        </Col>
        <Col md={8} xs={24}>
          <FormItem
            className="ant-input-group"
            label="Tác giả"
            name={["video", "tacGia"]}
            rules={[
              {
                type: "string",
                required: true,
                message: messages.ERROR_REQUIRED
              }
            ]}
            initialValue={tacGia}
          >
            <Input className="input-item" placeholder="Nhập tên tác giả" />
          </FormItem>
        </Col>
        <Col md={8} xs={24}>
          <FormItem
            className="QTI-FormItemSelect"
            label="Hạn lưu trữ"
            name={["video", "idHan"]}
            initialValue={idHan || undefined}
            rules={[
              {
                required: true,
                message: messages.ERROR_REQUIRED
              }
            ]}
          >
            <Select
              allowClear
              onChange={onChangeHanTuLieu}
              loading={isLoadingHan}
              placeholder="Chọn hạn lưu trữ"
              style={{ width: "100%" }}
              options={listHanLuuTru}
              fieldNames={{ label: "tenHanLuuTru", value: "id" }}
            />
          </FormItem>
        </Col>
        <Col md={4} xs={24}>
          <FormItem
            label="Ngày bắt đầu lưu trữ"
            name={["video", "ngayBatDauLT"]}
            rules={[
              {
                required: true,
                message: messages.ERROR_REQUIRED
              }
            ]}
            initialValue={ngayBatDauLT ? dayjs(ngayBatDauLT) : dayjs()}
          >
            <DatePicker
              allowClear={false}
              onChange={onChangeNgayBatDauLT}
              format="DD/MM/YYYY"
              placeholder="Chọn ngày bắt đầu lưu trữ"
              style={{ width: "100%" }}
            />
          </FormItem>
        </Col>
        {!isVinhVien && (
          <Col md={4} xs={24}>
            <FormItem
              className="QTI-FormItemSelect"
              label="Ngày kết thúc lưu trữ"
              name={["video", "ngayKetThucLT"]}
              rules={[
                {
                  required: true,
                  message: messages.ERROR_REQUIRED
                }
              ]}
              initialValue={ngayKetThucLT ? dayjs(ngayKetThucLT) : dayjs()}
            >
              <DatePicker
                allowClear={false}
                onChange={onChangeNgayKetThucLT}
                format="DD/MM/YYYY"
                placeholder="Chọn ngày kết thúc lưu trữ"
                style={{ width: "100%" }}
              />
            </FormItem>
          </Col>
        )}
        <Col md={24} xs={24}>
          <FormItem
            label="Mô tả"
            name={["video", "moTa"]}
            initialValue={moTa}
            rules={[
              {
                required: true,
                message: messages.ERROR_REQUIRED
              }
            ]}
          >
            <TextArea rows={3} placeholder="Nhập mô tả" />
          </FormItem>
        </Col>

        <Col md={24} xs={24} style={{ marginBottom: 30 }}>
          <FormItem
            label="Chi tiết"
            name={["video", "chiTiet"]}
            valuePropName="checked"
            initialValue={chiTiet}
          >
            <EditorInput value={chiTiet} />
          </FormItem>
        </Col>
      </Row>
      <hr />
      <FormActionButton
        goBack={goBack}
        save={save}
        loadingButton={loadingButton}
      />
    </Form>
  );
};

export default ThongTinTuLieuForm;
